<template>
  <v-app id="login" class="secondary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="@/assets/plantiful.jpg" alt="Vue Material Admin" width="180" height="70">
                  <h1 class="flex my-4 ">Plantifulbkk Admin</h1>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    v-model="userEmail"
                    :error="error"
                    :rules="[rules.required]"/>
                  <v-text-field
                    :type="hidePassword ? 'password' : 'text'"
                    :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                    name="password"
                    label="Password"
                    id="password"
                    :rules="[rules.required]"
                    v-model="password"
                    :error="error"
                    @click:append="hidePassword = !hidePassword"/>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn tile color="black" dark  @click="login" :loading="loading">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar
        v-model="showResult"
        :timeout="2000"
        top>
        {{ result }}
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      userEmail: '',
      password: '',
      hidePassword: true,
      error: false,
      showResult: false,
      result: '',
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },

  methods: {
    login() {
      const vm = this;

      if (!vm.userEmail || !vm.password) {

        alert( "Email and Password can't be null." )   
        return
      }
      
      vm.axios.get('https://ws.plantifulbkk.shop/get_users.php',{
        params: {
            scode : vm.userEmail ,
            spass : vm.password ,
        }
        }).then(response => {

          let result = JSON.parse(JSON.stringify(response.data))
          let ispass = result.length

          if ( ispass == 1 ) {

            this.$store.dispatch('set_branch_ac', result[0].branch )
            vm.$router.push({ name: 'Dashboard' });
          }
          else {        
            alert( "Email or Password is incorrect.")      
            return  
          }
        }).catch(function (error) {
            alert("Error")
            console.log(error)
        })


    }
  }
}
</script>

<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/core/Login.vue